<i18n
  src="@/locales/views/organization/production/delivery_container/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_containers')"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <template v-if="load_general_data">
    <bread-crumbs
      :labels="[
        module_name,
        `${agro_exporter_process.name} - ${agro_exporter_process?.agro_exporter?.name}`
      ]"
    />

    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i>
      <span class="space-icon"></span>
      {{ $t("labels.title") }} {{ container.container_code }}
    </h1>

    <alert-danger :errors_data="std_err" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200" v-if="container">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.week") }}
                </dt>
                <dd class="content-data">
                  {{ container.week }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <container-status :status_id="container.status_id" />
                </dd>
              </div>

              <!-- <div class="sm:col-span-3"> -->
              <!--   <dt class="label-data"> -->
              <!--     {{ $t("model.container.packing_house") }} -->
              <!--   </dt> -->
              <!--   <dd class="content-data"> -->
              <!--     {{ container.packing_house?.name }} -->
              <!--   </dd> -->
              <!-- </div> -->

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.load_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.load_date) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.customer") }}
                </dt>
                <dd class="content-data">
                  {{ container.customer?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.waybill") }}
                </dt>
                <dd class="content-data">
                  {{ container.waybill }}
                </dd>
              </div>

              <div class="sm:col-span-3" v-if="container.brand_name">
                <dt class="label-data">
                  {{ $t("model.container.exporter_process_brand") }}
                </dt>
                <dd class="content-data">
                  {{ container.brand_name }}
                </dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-8">
      <div class="flex flex-row justify-between">
        <div class="panel-plain-label">
          <badge-default
            :label="
              container_attachments.length +
              ' ' +
              $t('labels.total_number_attachs')
            "
          />
        </div>
        <uploader-attachment
          :organization_id="organization_id"
          :container_id="container_id"
          :container_files="container_files"
          @new="value => this.container_attachments.push(value)"
        ></uploader-attachment>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.container.container_attachments.exporter_process_container_file"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.container.container_attachments.container_attach"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell"></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="attachment in container_attachments"
                    :key="attachment.id"
                  >
                    <td class="table-cell">
                      {{ attachment.exporter_process_container_file?.name }}
                    </td>
                    <td class="table-cell-main">
                      {{ attachment.container_attach.blob.filename }}
                    </td>
                    <td class="table-cell-action space-x-1 space-y-1">
                      <destroy-button
                        v-if="!attachment.destroying"
                        :disabled_button="false"
                        @destroyEvent="destroyContainerAttachment(attachment)"
                        :title="$t('labels.destroy_button_attach_title', { file: attachment.exporter_process_container_file.name })"
                        :message="$t('labels.destroy_button_attach_message')"
                        :label_confirm="
                          $t('labels.destroy_button_attach_label_confirm')
                        "
                      />
                      <destroy-button-processing v-else />
                      <button
                        class="btn-white inline-flex"
                        @click.prevent="downloadContainerAttachment(attachment)"
                      >
                        <i
                          :class="[
                            'fa-solid ',
                            attachment.downloading
                              ? ' fa-sppiner'
                              : ' fa-download'
                          ]"
                        ></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/production/delivery_container/show_container.js";
import UploaderAttachment from "@/components/views/organization/production/delivery_container/UploaderAttachment.vue";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";

export default {
  name: "OrgProductionDeliveryContainerShowContainer",
  components: {
    UploaderAttachment,
    ContainerStatus
  },
  props: {
    agro_exporter_process_id: { required: true },
    container_id: { required: true },
    organization_id: { required: true }
  },
  data() {
    return {
      load_general_data: false,
      agro_exporter_process: {},
      container: {},
      container_files: [],
      container_attachments: []
    };
  },
  methods: {
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchContainerAttachments();
      this.fetchContainerFiles();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.organization_id,
        this.agro_exporter_process_id
      );

      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.organization_id,
        this.container_id
      );

      this.container = response.data;
    },
    fetchContainerFiles: async function () {
      let response = await Requester.fetchContainerFiles(
        this.organization_id,
        this.agro_exporter_process_id
      );

      this.container_files = response.data;
    },
    fetchContainerAttachments: async function () {
      let response = await Requester.fetchContainerAttachments(
        this.organization_id,
        this.container_id
      );

      this.container_attachments = response.data.map(container_attachment => {
        return {
          ...container_attachment,
          downloading: false,
          destroying: false
        };
      });
    },
    destroyContainerAttachment: async function (container_attachment) {
      container_attachment.destroying = true;
      try {
        var response = await Requester.destroyContainerAttachment(
          this.organization_id,
          container_attachment.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.container_attachments.splice(
          this.container_attachments.indexOf(container_attachment),
          1
        );
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      container_attachment.destroying = false;
    },
    downloadContainerAttachment: async function (container_attachment) {
      container_attachment.downloading = true;
      var response = await Requester.downloadContainerAttachment(
        this.organization_id,
        container_attachment.id
      );
      const file = response.data;
      this.downloadFile(
        file,
        container_attachment.container_attach.blob.filename
      );
      container_attachment.downloading = false;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => {
        this.loadData();
      })
    );
  }
};
</script>
